import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';


import { TermsAndConditionsRouteGuard } from '../Bootstrap/components/TermsAndConditions/terms-and-conditions.guard';
import { LandingPageComponent } from './components/LandingPage/landingPage.component';
import { LandingPageGuard } from './services/landing-page-guard.service';

@NgModule({
    imports: [
        RouterModule.forChild([
            // classic redirect points to dashboard & not Dashboard
            ...['LandingPage', 'landingpage'].map(path => ({
                path: path,
                component: LandingPageComponent,
                data: {title: 'Dashboard.browserTitle'},
                canActivate: [ LandingPageGuard, TermsAndConditionsRouteGuard ],
            }))
        ])
    ],
    exports: [
        RouterModule
    ]
})
export class LandingPageRoutingModule {}
